import { c as _c } from "react-compiler-runtime";
import React from "react";
import { Button, Input as AriaInput, Select as AriaSelect, SelectValue as AriaSelectValue } from "react-aria-components";
import { ListBox } from "./ListBox.js";
import { Popover } from "./Popover.js";
import { inputDropdown, inputDropdownContainer, selectText } from "./UnitInput.css.js";
import { ChevronButton } from "./shared/ChevronButton.js";
import { InputBuilder } from "./shared/InputBuilder.js";
import { extractInputBuilderProps } from "./shared/inputBuilderHelper.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SelectValue = t0 => {
  const $ = _c(3);
  const {
    size,
    placeholder
  } = t0;
  let t1;
  if ($[0] !== placeholder || $[1] !== size) {
    t1 = /*#__PURE__*/_jsx(AriaSelectValue, {
      children: t2 => {
        const {
          selectedText,
          isPlaceholder
        } = t2;
        return isPlaceholder ? /*#__PURE__*/_jsx("span", {
          className: selectText({
            size,
            type: "placeholder"
          }),
          children: placeholder
        }) : /*#__PURE__*/_jsx("span", {
          className: selectText({
            size,
            type: "text"
          }),
          children: selectedText
        });
      }
    });
    $[0] = placeholder;
    $[1] = size;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export function UnitDropdown(t0) {
  const $ = _c(24);
  let children;
  let popoverWidth;
  let props;
  let t1;
  let triggerRef;
  let unitPlaceholder;
  if ($[0] !== t0) {
    ({
      children,
      unitPlaceholder,
      popoverWidth,
      size: t1,
      triggerRef,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = popoverWidth;
    $[3] = props;
    $[4] = t1;
    $[5] = triggerRef;
    $[6] = unitPlaceholder;
  } else {
    children = $[1];
    popoverWidth = $[2];
    props = $[3];
    t1 = $[4];
    triggerRef = $[5];
    unitPlaceholder = $[6];
  }
  const size = t1 === undefined ? "m" : t1;
  const ref = React.useRef(null);
  const width = popoverWidth;
  let t2;
  if ($[7] !== size || $[8] !== unitPlaceholder) {
    t2 = /*#__PURE__*/_jsx(SelectValue, {
      size: size,
      placeholder: unitPlaceholder
    });
    $[7] = size;
    $[8] = unitPlaceholder;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsx(ChevronButton, {
      element: "div"
    });
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2) {
    t4 = /*#__PURE__*/_jsxs(Button, {
      ref: ref,
      className: inputDropdown,
      children: [t2, t3]
    });
    $[11] = t2;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = triggerRef ?? ref;
  let t6;
  if ($[13] !== children || $[14] !== size) {
    t6 = /*#__PURE__*/_jsx(ListBox, {
      size: size,
      children: children
    });
    $[13] = children;
    $[14] = size;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6 || $[18] !== width) {
    t7 = /*#__PURE__*/_jsx(Popover, {
      placement: "bottom end",
      shouldFlip: true,
      triggerRef: t5,
      width: width,
      children: t6
    });
    $[16] = t5;
    $[17] = t6;
    $[18] = width;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== props || $[21] !== t4 || $[22] !== t7) {
    t8 = /*#__PURE__*/_jsxs(AriaSelect, {
      ...props,
      className: inputDropdownContainer,
      children: [t4, t7]
    });
    $[20] = props;
    $[21] = t4;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}
export function UnitInput(t0) {
  const $ = _c(27);
  let children;
  let t1;
  let unitLabel;
  if ($[0] !== t0) {
    const {
      children: t2,
      unitLabel: t3,
      ...props
    } = t0;
    children = t2;
    unitLabel = t3;
    t1 = extractInputBuilderProps(props);
    $[0] = t0;
    $[1] = children;
    $[2] = t1;
    $[3] = unitLabel;
  } else {
    children = $[1];
    t1 = $[2];
    unitLabel = $[3];
  }
  const {
    inputBuilderProps,
    restProps
  } = t1;
  let defaultUnit;
  let inputProps;
  let onUnitChange;
  let popoverWidth;
  let unit;
  let unitPlaceholder;
  if ($[4] !== restProps) {
    ({
      unitPlaceholder,
      onUnitChange,
      unit,
      defaultUnit,
      popoverWidth,
      ...inputProps
    } = restProps);
    $[4] = restProps;
    $[5] = defaultUnit;
    $[6] = inputProps;
    $[7] = onUnitChange;
    $[8] = popoverWidth;
    $[9] = unit;
    $[10] = unitPlaceholder;
  } else {
    defaultUnit = $[5];
    inputProps = $[6];
    onUnitChange = $[7];
    popoverWidth = $[8];
    unit = $[9];
    unitPlaceholder = $[10];
  }
  const ref = React.useRef(null);
  const size = inputBuilderProps.size ?? "m";
  let t2;
  if ($[11] !== children || $[12] !== defaultUnit || $[13] !== onUnitChange || $[14] !== popoverWidth || $[15] !== size || $[16] !== unit || $[17] !== unitLabel || $[18] !== unitPlaceholder) {
    t2 = /*#__PURE__*/_jsx(UnitDropdown, {
      "aria-label": unitLabel,
      unitPlaceholder: unitPlaceholder,
      onUnitChange: onUnitChange,
      unit: unit,
      defaultUnit: defaultUnit,
      popoverWidth: popoverWidth,
      size: size,
      triggerRef: ref,
      children: children
    });
    $[11] = children;
    $[12] = defaultUnit;
    $[13] = onUnitChange;
    $[14] = popoverWidth;
    $[15] = size;
    $[16] = unit;
    $[17] = unitLabel;
    $[18] = unitPlaceholder;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  let t3;
  if ($[20] !== inputProps) {
    t3 = /*#__PURE__*/_jsx(AriaInput, {
      ...inputProps
    });
    $[20] = inputProps;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  let t4;
  if ($[22] !== inputBuilderProps || $[23] !== size || $[24] !== t2 || $[25] !== t3) {
    t4 = /*#__PURE__*/_jsx(InputBuilder, {
      ...inputBuilderProps,
      ref: ref,
      size: size,
      right: t2,
      children: t3
    });
    $[22] = inputBuilderProps;
    $[23] = size;
    $[24] = t2;
    $[25] = t3;
    $[26] = t4;
  } else {
    t4 = $[26];
  }
  return t4;
}
//# sourceMappingURL=UnitInput.js.map